import { makeAutoObservable } from 'mobx'
import { ShopRootStore } from 'shop/stores/shopRoot.store'

import { StripeElementsOptionsMode } from 'shop/types/stripe'
import { StripePaymentElement } from '../../interfaces/payment-method-interfaces/StripePaymentMethod'

export class ShopIdealPaymentMethodStore implements StripePaymentElement {
  storeName = 'shopIdealPaymentMethodStore'
  root: ShopRootStore = null

  constructor(root: ShopRootStore) {
    this.root = root

    makeAutoObservable(this)
  }

  getStripeElementPayload = ({
    isDealsPage,
    isManagePage,
  }: {
    isDealsPage: boolean
    isManagePage: boolean
  }): StripeElementsOptionsMode => {
    const emptyValue: StripeElementsOptionsMode = {
      mode: 'payment',
      paymentMethodTypes: [],
      currency: '',
      amount: 0,
    }
    if (isDealsPage) {
      return (
        (this.root.dealsStore?.getIdealStripeElementPayload && this.root.dealsStore.getIdealStripeElementPayload()) ||
        emptyValue
      )
    } else if (isManagePage) {
      return (
        (this.root.ordersStore?.getIdealStripeElementPayload && this.root.ordersStore.getIdealStripeElementPayload()) ||
        emptyValue
      )
    } else {
      return (
        (this.root.paymentStore?.getIdealStripeElementPayload &&
          this.root.paymentStore.getIdealStripeElementPayload()) ||
        emptyValue
      )
    }
  }
}
